import { render, staticRenderFns } from "./MessagesChat.vue?vue&type=template&id=62959a75&"
import script from "./MessagesChat.vue?vue&type=script&lang=js&"
export * from "./MessagesChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports